// This plugin looks for any axios errors and shows 404 page where appropriate
export default function ({ $axios, error }, inject) {
    $axios.defaults.timeout = 30000

    // TODO: what happens on 500 :)
    // CMS api returns 403 when you send it /snarf/blat/
    inject('axiosError', () => error({ statusCode: 404, message: 'Not Found' }))
}
